import { registerFeatureWithDescription } from "lib/features"
import { FEATURE_FLAG_AUTHORING_PUBLISH } from "authoring/lib/enum/authoring-feature-flags.mjs"

registerFeatureWithDescription({
    numericalId: 406,
    id: FEATURE_FLAG_AUTHORING_PUBLISH,
    name: "Publish approved schedules directly to Legacy",
    internalUseOnly: true,
    descriptionLines: ["When enabled, approved drafts are promoted directly to the live version in Legacy."],
})

export { FEATURE_FLAG_AUTHORING_PUBLISH }
